// eslint-disable-next-line no-relative-import-paths/no-relative-import-paths
import PackageJson from "../../package.json"
import {type Environment} from "@environment/types"

/**
 * Configuration for preview deployments (i.e. all deployments to non-prod environments).
 */
export const environment: Environment = {
    production: true,
    name: "dev3",
    version: PackageJson.version,

    auth: {
        google: {
            clientId: "608675176242-9a7778mmllu4026o5m3ehi2n58vir03n.apps.googleusercontent.com",
        },
        microsoft: {
            clientId: "151d8cd7-eff9-441e-b8b9-1072287949cb",
        },
    },

    firebase: {
        apiKey: "AIzaSyCWN5t2AAgAMtGWs-ARgrtQPbWGutxHWw0",
        authDomain: "cm-platform-dev3.firebaseapp.com",
        projectId: "cm-platform-dev3",
        storageBucket: "cm-platform-dev3.firebasestorage.app",
        messagingSenderId: "179260187805",
        appId: "1:179260187805:web:fa8eb2b4c76737b82b6074",
        measurementId: "G-QJCEYNJ8QZ",
    },
    firebaseConfig: {
        collectionEnabled: true,
    },

    rendering: {
        materialAssets: {
            fallbackTemplateId: 17484,
            samples: 64,
        },
        shaderBall: {
            templateId: 17482,
        },
        defaultQueueDomain: "colormass",
        maxConcurrentRenderJobs: 200,
    },

    storage: {
        bucketsPrefix: "cm-platform-dev3-",
        usePostToUpload: false,
    },

    style: {
        application: {
            background: "#991b1b40",
        },
    },

    debug: {
        enableCallStack: false,
    },

    onboarding: {
        allowSkipPayment: false,
    },

    stripe: {
        fullyIntegrated: false,
    },

    configuratorUrl: "https://configurator-dev3.colormass.com?apiVersion=2",
    platformDeployUrl: "https://dev3.colormass.com",
    configuratorDeployUrl: "https://configurator-dev3.colormass.com",
    gqlApiEndpoint: "https://gql-dev3.colormass.com",
    jobsInstanceUrl: "https://jobs-dev3.colormass.com",
    localTilingEndpoint: "ws://localhost:5678/",

    defaultRenderQueueDomain: "render",
}
